import React from 'react';
import moment from 'moment';
import api from 'api';
import { CalendarLayout, Modal, DropdownSelector, Spinner, DatePicker } from 'hyperdb-utils';
import Calendar from '../components/Calendar';
import CalendarFilters from '../components/CalendarFilters';
import ModalReservationInfo from '../components/ModalReservationInfo';
import ModalSelectedDates from '../components/ModalSelectedDates';

class CalendarContainer extends React.Component {
  constructor(props) {
    super(props);
    this.initialized = false;
    this.handleChangeDate = this.handleChangeDate.bind(this);
    this.handleDatesRangeSelected = this.handleDatesRangeSelected.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
    this.handleCloseModalDatesSelected = this.handleCloseModalDatesSelected.bind(this);
    this.handleSubmitAction = this.handleSubmitAction.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleClickReservation = this.handleClickReservation.bind(this);
    this.handleCloseModalReservationInfo = this.handleCloseModalReservationInfo.bind(this);
  }
  componentDidMount() {
    const today = moment();
    const calendarFilters = {};
    const { currentUser } = this.props.api.getState('auth');
    if (this.props.booking) {
      const bookingDate = moment(this.props.booking.arrival_date);
      this.props.api.availabilities.setData({
        selectedYear: bookingDate.year(),
        selectedMonth: bookingDate.month(),
        selectedDay: bookingDate.date(),
        calendarFilters,
      });
      calendarFilters.properties_ids = [this.props.booking.property.id || this.props.booking.value[1]];
      this.initialized = true;
      this.handleSearch(calendarFilters);
    } else if (currentUser.group.name === 'owner' && currentUser.person_id) {
      calendarFilters.owner_id = currentUser.person_id || -1;
      this.initialized = true;
      this.handleSearch(calendarFilters);
    } else {
      this.props.api.availabilities.setData({
        selectedYear: today.year(),
        selectedMonth: today.month(),
        selectedDay: today.date(),
        calendarFilters,
      });
    }
    if (!this.props.noFilters) {
      if (['admin', 'manager'].includes(currentUser.group.name)) {
        this.props.api.propertyGroup.getObjects({
          propName: 'groups',
          queryOptions: [['id', 'name'], { order: { name: 'asc' } }],
        });
        this.props.api.owner.getObjects({
          propName: 'owners',
          queryOptions: [['id', 'name'], { order: { name: 'asc' } }],
        });
      }
      const zonesIds = currentUser.client_id === '3912abc1' || currentUser.client_id === '12345678' ? ['18425409708756'] : ['18425409786216', '18425409810792']; // TODO
      this.props.api.zone.getObjects({
        propName: 'zones',
        queryOptions: [['id', 'name'], { order: { name: 'asc' }, where: { id: { in: zonesIds } } }],
      });
      this.props.api.area.getObjects({
        propName: 'areas',
        queryOptions: [['id', 'name'], { order: { name: 'asc' }, where: { 'zone.id': { in: zonesIds } } }],
      });
    }
  }
  componentWillReceiveProps(nextProps) {
    const groups = nextProps.api.getState('propertyGroup').groups;
    if (groups && !this.initialized) {
      this.initialized = true;
      this.handleSearch();
    }
    if (this.props.api.getState('blockedDateRange').postDataSuccessful) {
      this.props.api.blockedDateRange.setData({ postDataSuccessful: false });
      this.handleSearch(nextProps.calendarFilters);
    }
  }
  componentWillUnmount() {
    this.props.api.availabilities.setData({
      displayedReservation: null,
    });
  }
  render() {
    const { selectedYear, selectedMonth, selectedDay } = this.props;
    const calendarDates = this.getListDates({ year: selectedYear, month: selectedMonth, day: selectedDay });
    const from = calendarDates[0].stringISO;
    const to = calendarDates.slice(-1)[0].stringISO;
    const units = this.getUnitsAvailabilities(calendarDates);
    const { currentUser } = this.props.api.getState('auth');
    return (
      <CalendarContentWrapper contentOnly={ this.props.contentOnly }>
        <Spinner show={ this.props.loading } />
        {
          !this.props.noFilters
            ? <CalendarFilters
                { ...this.props }
                currentUser={ currentUser }
                groups={ this.props.api.getState('propertyGroup').groups || [] }
                owners={ this.props.api.getState('owner').owners || [] }
                zones={ this.props.api.getState('zone').zones || [] }
                areas={ this.props.api.getState('area').areas || [] }
                onSelect={ this.handleSelect.bind(this, 'calendarFilters') }
                onSubmit={ this.handleSearch }
              />
            : null
        }
        <br/><br/>
        <CalendarLayout
          minYear={ moment().subtract(1, 'year').format('YYYY') }
          maxYear={ moment().add(1, 'year').format('YYYY') }
          year={ selectedYear }
          month={ selectedMonth }
          day={ selectedDay }
          calendarDates={ calendarDates }
          onChangeDate={ this.handleChangeDate }
          onDatesRangeSelected={ this.handleDatesRangeSelected }
        >
          <Calendar units={ units } reservations={ (this.props.calendarParams || {}).reservations } onClickReservation={ this.handleClickReservation } />
        </CalendarLayout>
        {
          this.props.displayedReservation
            ? <ModalReservationInfo
                currentUser={ currentUser }
                reservation={ this.props.displayedReservation }
                onClose={ this.handleCloseModalReservationInfo } />
            : null
        }
        {
          this.props.showModalSelectedDates
            ? <ModalSelectedDates
                { ...this.props }
                units={ this.props.calendarParams.units }
                onChange={ this.handleSelect }
                onClose={ this.handleCloseModalDatesSelected }
                onConfirmAction={ this.handleSubmitAction }
                loading={ this.props.api.getState('blockedDateRange').loading }
              />
            : null
        }
      </CalendarContentWrapper>
    );
    // return (
    //   <div className="content-wrapper">
    //     <section className="content-header content-header-fixed">
    //       <div className="row">
    //         <div className="col-md-7">
    //           &nbsp; <h3 className="box-title">Availabilities calendar</h3>
    //         </div>
    //       </div>
    //     </section>
    //     <section className="content content-fixed">
    //       <div className="box box-body">
    //         <Spinner show={ this.props.loading } />
    //         <CalendarFilters
    //           { ...this.props }
    //           currentUser={ currentUser }
    //           groups={ this.props.api.getState('propertyGroup').groups || [] }
    //           owners={ this.props.api.getState('owner').owners || [] }
    //           zones={ this.props.api.getState('zone').zones || [] }
    //           areas={ this.props.api.getState('area').areas || [] }
    //           onSelect={ this.handleSelect.bind(this, 'calendarFilters') }
    //           onSubmit={ this.handleSearch }
    //         />
    //         <br/><br/>
    //         <CalendarLayout
    //           minYear={ moment().subtract(1, 'year').format('YYYY') }
    //           maxYear={ moment().add(1, 'year').format('YYYY') }
    //           year={ selectedYear }
    //           month={ selectedMonth }
    //           day={ selectedDay }
    //           calendarDates={ calendarDates }
    //           onChangeDate={ this.handleChangeDate }
    //           onDatesRangeSelected={ this.handleDatesRangeSelected }
    //         >
    //           <Calendar units={ units } reservations={ (this.props.calendarParams || {}).reservations } onClickReservation={ this.handleClickReservation } />
    //         </CalendarLayout>
    //       </div>
    //     </section>
    //     {
    //       this.props.displayedReservation
    //         ? <ModalReservationInfo
    //             currentUser={ currentUser }
    //             reservation={ this.props.displayedReservation }
    //             onClose={ this.handleCloseModalReservationInfo } />
    //         : null
    //     }
    //     {
    //       this.props.showModalSelectedDates
    //         ? <ModalSelectedDates
    //             { ...this.props }
    //             units={ this.props.calendarParams.units }
    //             onChange={ this.handleSelect }
    //             onClose={ this.handleCloseModalDatesSelected }
    //             onConfirmAction={ this.handleSubmitAction }
    //             loading={ this.props.api.getState('blockedDateRange').loading }
    //           />
    //         : null
    //     }
    //   </div>
    // );
  }

  getListDates({ year, month, day }) {
    const date = moment({ year, month, day });
    const isMonday = date.isoWeekday() === 1;
    const start = isMonday ? date.subtract(7, 'days') : date.startOf('isoWeek');
    const end = start.clone().add(41, 'days');
    const listDates = [];
    for (let currentDate = start; currentDate.isSameOrBefore(end); currentDate.add(1, 'days')) {
      const currentDay = this.getListDays()[currentDate.isoWeekday() - 1];
      const dateParams = { stringISO: currentDate.format('YYYY-MM-DD'), label: `${currentDay.short} ${currentDate.format('DD')}` };
      listDates.push(dateParams);
    }
    return listDates;
  }
  getListDays() {
    return [
      { name: 'Monday', short: 'Mo', value: 1 },
      { name: 'Tuesday', short: 'Tu', value: 2 },
      { name: 'Wednesday', short: 'We', value: 3 },
      { name: 'Thursday', short: 'Th', value: 4 },
      { name: 'Friday', short: 'Fr', value: 5 },
      { name: 'Saturday', short: 'Sa', value: 6 },
      { name: 'Sunday', short: 'Su', value: 7 },
    ];
  }

  getUnitsAvailabilities(calendarDates) {
    if (!this.props.calendarParams) return [];
    const dateFrom = calendarDates[0].stringISO;
    const dateTo = calendarDates.slice(-1)[0].stringISO;
    const { units, reservations } = this.props.calendarParams;
    return units.map(unit => {
      let dates = unit.dates.filter(date => date.until >= dateFrom && date.day <= dateTo);
      const max = dates.length - 1;
      dates = dates
        .map((date, i) => {
          const day = (i === 0 && date.day < dateFrom) ? dateFrom : date.day;
          const until = (i === max && date.until > dateTo) ? dateTo : date.until;
          const nbDays = moment(until).diff(day, 'days') + 1;
          return { ...date, day, until, nb_days: nbDays };
        });
      return { ...unit, dates };
    });
  }

  handleSearch(filters = {}) {
    const conditions = [];
    const groups = this.props.api.getState('propertyGroup').groups || [];
    const firstGroup = groups.length > 0 ? groups[0].id : null;
    if (!filters.owner_id) {
      const { currentUser } = this.props.api.getState('auth');
      if (currentUser.group.name === 'owner' && currentUser.person_id) filters.owner_id = currentUser.person_id || -1;
    }
    if (!filters.group_id && firstGroup) conditions.push(`group.id=${firstGroup}`);
    if (filters.group_id && filters.group_id !== 'all') conditions.push(`group.id=${filters.group_id}`);
    if (filters.owner_id && filters.owner_id !== 'all') conditions.push(`owner.id=${filters.owner_id}`);
    if (filters.zone_id && filters.zone_id !== 'all') conditions.push(`zone.id=${filters.zone_id}`);
    if (filters.area_id && filters.area_id !== 'all') conditions.push(`main_area=${filters.area_id}`);
    if (filters.properties_ids && filters.properties_ids !== 'all') conditions.push(`ids=${filters.properties_ids.join(',')}`);
    let url = '/calendar';
    if (conditions.length > 0) url += `?${conditions.join('&')}`;
    this.handleCloseModalDatesSelected();
    this.props.api.availabilities.getData({
      url,
      propName: 'calendarParams',
    });
  }

  handleClickReservation(reference) {
    const displayedReservation = this.props.calendarParams.reservations.find(r => r.reference === reference) || null;
    this.props.api.availabilities.setData({ displayedReservation });
  }
  handleCloseModalReservationInfo() {
    this.props.api.availabilities.setData({ displayedReservation: null });
  }

  handleChangeDate({ year, month, day }) {
    this.props.api.availabilities.setData({
      selectedYear: year,
      selectedMonth: month,
      selectedDay: day,
    });
  }
  handleDatesRangeSelected(dates) {
    this.props.api.availabilities.setData({
      showModalSelectedDates: true,
      dateFrom: dates[0],
      dateTo: dates[1],
      actionDatesSelected: '',
      selectedUnit: '',
    });
  }
  handleCloseModalDatesSelected() {
    this.props.api.availabilities.setData({
      showModalSelectedDates: false,
      dateFrom: null,
      dateTo: null,
      actionDatesSelected: '',
      selectedUnit: '',
    });
  }
  handleSelect(attributeName, field) {
    const { name, value } = field;
    this.props.api.availabilities.setData({ [attributeName]: value });
  }
  handleSubmitAction() {
    if (!this.props.actionDatesSelected) return;
    const [propertyId, unitNumber] = this.props.selectedUnit.split('_');
    const params = { blocked_by: 'PMS', property_id: propertyId, unit_number: unitNumber, date_from: this.props.dateFrom, date_to: this.props.dateTo };
    const action = this.props.actionDatesSelected === 'block'
      ? this.props.api.blockedDateRange.blockDates
      : this.props.api.blockedDateRange.unblockDates;
    action(params);
  }
}

export default api.connect(CalendarContainer, 'availabilities');

const CalendarContentWrapper = ({ contentOnly = false, children }) => {
  if (contentOnly) return <div>{ children }</div>;
  return (
    <div className="content-wrapper">
      <section className="content-header content-header-fixed">
        <div className="row">
          <div className="col-md-7">
            &nbsp; <h3 className="box-title">Availabilities calendar</h3>
          </div>
        </div>
      </section>
      <section className="content content-fixed">
        <div className="box box-body">
          {
            children
          }
        </div>
      </section>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/frontend/modules/daily-rental/availabilities/containers/Calendar.jsx